import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-neutral-100 report-layout-root" }


export default /*@__PURE__*/_defineComponent({
  __name: 'report',
  setup(__props) {

// Minimal layout for report pages optimized for PDF generation
// No navigation, no sidebars, just content

const colorMode = useColorMode();
const route = useRoute();

// Full-bleed margin: 0 for life-story variants and for child/resident profile
// and FPP PDFs. The component supplies its own inner padding so it survives
// browser print-dialog margin settings. Everything else keeps the safe 12mm margin.
// const pageMargin = computed(() =>
//   route.query.variant ||
//   route.path.startsWith("/pdf/child/") ||
//   route.path.startsWith("/pdf/resident/") ||
//   route.path.startsWith("/pdf/family-placement-plan/") ||
//   route.path.startsWith("/pdf/initial-risk-assessment/") ||
//   route.path.startsWith("/pdf/report/")
//     ? "0"
//     : "12mm",
// );

// useHead(() => {
//   // Single global @page rule. Named @page rules (e.g. editorial, infographic,
//   // resident, child) live inside the render component that needs them so each
//   // owns its own bottom margin and running-footer wiring without competing
//   // with siblings.
//   const baseRule = `@page { size: A4; margin: ${pageMargin.value}; }`;

//   return {
//     style: [
//       {
//         children: baseRule,
//       },
//     ],
//   };
// });

// Force light mode for consistent PDF generation
onMounted(() => {
  colorMode.preference = "light";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}
}

})